import {FormControl} from '@angular/forms';

export function updateControlIfUnique(control: FormControl, value: any): void {
    if (control.value !== value) control.patchValue(value);
}
